<template>
  <div class="marketo-form">
    <SloLoader v-if="loading" :loading="true" size="lg" :color="loaderColor" />
    <div v-else-if="success" v-html="successMessage" class="marketo-success" />
    <form v-else :id="[`mktoForm_${formId}`]"></form>
  </div>
</template>

<script>
import SloLoader from './SloLoader.vue';

export default {
  name: 'SloMarketoForm',
  components: {SloLoader},
  data() {
    return {
      loading: false,
      success: false
    };
  },
  props: {
    formId: {type: String, required: true},
    loaderColor: {type: String, default: 'blue'},
    successMessage: {type: String, default: 'Thank you for your submission.'}
  },
  created() {
    // eslint-disable-next-line no-undef
    MktoForms2.loadForm('//info.sloan.com', '905-IOZ-761', this.formId, form => {
      form.onSubmit(() => {
        this.loading = true;
        this.success = false;
      });

      form.onSuccess(() => {
        this.loading = false;
        this.success = true;
        return false;
      });
    });
  }
};
</script>

<style lang="scss">
@import '../../scss/variables';
@import '../../scss/system';
@import '../../node_modules/bootstrap-sass/assets/stylesheets/bootstrap/mixins/*';
@import '../../node_modules/bootstrap-sass/assets/stylesheets/bootstrap/alerts';

.marketo-form {
  * {
    margin: 0;
    float: none !important;
  }
  .mktoOffset,
  .mktoGutter,
  .mktoClear,
  .mktoErrorArrowWrap {
    display: none !important;
  }
  .mktoButtonWrap, .mktoFieldDescriptor {
    margin: 0 !important;
  }

  .mktoForm input[type="text"],
  .mktoForm input[type="url"],
  .mktoForm input[type="email"],
  .mktoForm input[type="tel"],
  .mktoForm input[type="number"],
  .mktoForm input[type="date"],
  .mktoForm textarea.mktoField,
  .mktoForm select.mktoField {
    height: 48px;
    width: 100% !important;
    padding: 12px 16px;
    border: 1px solid $color-gray-400;
    border-radius: 4px;
    font-size: 16px;
    transition: border-color 0.1s ease-in-out;

    &:focus {
      border-color: $color-blue-400;
      outline: 1px solid transparent !important;
      box-shadow: 0 0 0 1px $color-blue-400 !important;
    }
  }

  .mktoButtonRow {
    margin-top: 16px;
  }

  .mktoButton {
    height: 48px;
    padding: 0 16px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 48px;
    background-color: $color-blue-400;
    color: $color-white;
    transition: background-color 0.1s ease-in-out;

    &:hover {
      background-color: $color-blue-700;
    }
  }

  .mktoForm {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    width: 100% !important;

    > div {
      flex: 1 1 100%;

      @media (min-width: 768px) {
        flex: 1 1 calc(42% - 16px);
      }
    }
  }

  .mktoLabel {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-bottom: 8px;
    width: 100% !important;
  }

  .mktoRadioList {
    display: flex;
    align-items: center;
    gap: 4px;

    label {
      margin: 0 !important;
    }

    label + input {
      margin-left: 16px !important;
    }
  }

  select {
    background-image: url("data:image/svg+xml;utf8,<svg fill='currentColor' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position: right 16px center;
  }

  .mktoForm .mktoError {
    position: static;
  }

  .marketo-success {
    display: block;
    padding: 16px 0;
  }

  .mktoForm .mktoError .mktoErrorMsg {
    color: $color-red-400;
    margin-top: 0;
    font-size: 14px;
    background-color: transparent;
    background-image: none;
    border: none;
    border-radius: initial;
    text-shadow: none;
    box-shadow: none;
  }
}

.blog-header {
  .marketo-form {
    display: none;

    @media (min-width: 768px) {
      display: block;
      flex: 0 0 70%;

      .mktoForm {
        max-width: 345px;
        margin-right: 0;
        margin-left: auto;
      }

      .mktoFormRow {
        flex: 1 1 auto;
      }

      .mktoButtonRow {
        flex: 0 1 0;
        margin-top: 0;
      }

      .mktoLabel {
        display: none;
      }
    }

    @media (min-width: 1220px) {
      flex: 0 0 80%;
    }
  }

  .marketo-form .mktoForm .mktoError {
    position: absolute;
    right: auto !important;
  }

  .marketo-success {
    text-align: end;
    color: $color-white;
  }

  .scrolled {
    .marketo-success {
      color: $color-gray-900;
    }
  }
}

.stay-up-to-date {
  .mktoForm {
    margin-top: 16px;
    align-items: end;

    @media (min-width: 768px) {
      margin-top: 32px;
    }

    label {
      display: none !important;
    }

    .mktoButtonRow {
      margin-top: 0;
    }
  }
}

#sloan-showroom-form {
  .mktoForm {
    > div {
      &:nth-of-type(1), &:nth-of-type(2) {
        display: flex;
        flex-direction: column;
        gap: 16px;

        @media (min-width: 768px) {
          flex-direction: row;
        }

        & > div {
          flex: 1 1 100%;
        }
      }

      @media (min-width: 768px) {
        flex: 1 1 100%;
      }
    }
  }
}

.iot-form--wrapper .marketo-form {
  margin-block: 32px;

  .mktoForm {
    > div {
      flex: 1 1 100%;
      display: grid;
      gap: 16px;
    }

    @media (min-width: 768px) {
      > div {
        grid-template-columns: 1fr 1fr;
      }

      & > div:nth-child(6) {
        .mktoFieldDescriptor {
          grid-column: span 2;
        }

        .mktoFieldWrap {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .mktoLabel {
          width: auto !important;
          padding-top: 0;
          margin-bottom: 0;
        }
      }
    }
  }

  .marketo-success {
    display: block;
    padding: 16px;
    border: 1px solid $color-gray-900;
    border-radius: 4px;

    &:before {
      content: '';
      display: block;
      width: 100%;
      max-width: 32px;
      height: 32px;
      margin-inline: auto;
      margin-bottom: 8px;
      background-color: $color-green-400;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white" width="18px" height="18px"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 20px;
      border-radius: 9999px;
    }
  }
}

.footer-nav {
  .marketo-form {
    .mktoForm {
      max-width: 345px;
    }

    .mktoFormRow {
      flex: 1 1 auto;
    }

    .mktoButtonRow {
      flex: 0 1 0;
      margin-top: 0;
    }
  }
}

.sink-service-form {
  .mktoForm {
    .mktoFormRow {
      flex: 1 1 100%;
      display: grid;
      gap: 16px;

      @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
      }

      &:nth-child(6) {
        display: none;
      }
    }
  }

  .marketo-error {
    @extend .alert;
    @extend .alert-danger;
    display: none;
    margin: 5px 0 15px;
  }
}
</style>
